// src/components/TimeworksPresskit.tsx
import PresskitTemplate from "./PresskitTemplate";
import logo1 from "../assets/presskit/TimeworksLogo1.png";
import logo2 from "../assets/presskit/TimeworksLogo2.png";
import mascot1 from "../assets/presskit/TimeworksMascot1.png";
import mascot2 from "../assets/presskit/TimeworksMascot2.png";
import mascot3 from "../assets/presskit/TimeworksMascot3.png";
import mascot4 from "../assets/presskit/TimeworksMascot4.png";
import mascot5 from "../assets/presskit/TImeworksMascot5.png";
import mascot6 from "../assets/presskit/TImeworksMascot6.png";
import banner1 from "../assets/presskit/TimeworksBanner1.png";
import banner2 from "../assets/presskit/TimeworksBanner2.png";
import banner3 from "../assets/presskit/TimeworksBanner3.png";
import screenshot1 from "../assets/presskit/TimeworksScreenshot1.png";
import screenshot2 from "../assets/presskit/TimeworksScreenshot2.png";
import screenshot3 from "../assets/presskit/TimeworksScreenshot3.png";
import screenshot4 from "../assets/presskit/TimeworksScreenshot4.png";
import screenshot5 from "../assets/presskit/TimeworksScreenshot5.png";
import screenshot6 from "../assets/presskit/TimeworksScreenshot6.png";
import screenshot7 from "../assets/presskit/TimeworksScreenshot7.png";
import screenshot8 from "../assets/presskit/TimeworksScreenshot8.png";
import screenshot9 from "../assets/presskit/TimeworksScreenshot9.png";
import screenshot10 from "../assets/presskit/TimeworksScreenshot10.png";
import screenshot11 from "../assets/presskit/TimeworksScreenshot11.png";
import screenshot12 from "../assets/presskit/TimeworksScreenshot12.png";
import screenshot13 from "../assets/presskit/TimeworksScreenshot13.png";
import screenshot14 from "../assets/presskit/TimeworksScreenshot14.png";

const TimeworksPresskit = () => {
  return (
    <PresskitTemplate
      title="Timeworks"
      developer="Starworks Studios"
      publisher="Starworks Studios"
      platform="PC (Steam)"
      socialMedia="https://linktr.ee/starworksstudios"
      website="https://www.starworks-studios.com/games/timeworks"
      description={'Timeworks is a time-traveling 3D puzzle platformer with a bouncy cartoon style. Work along past versions of yourself to solve puzzles, create unique Items, and fill out your quotas for your mysterious employers.\nYou’re a new hire at the Timeworks corporation, an enigmatic company that “pioneers time travel technology.” Your first day is pretty typical; your supervisor flings you through time and space in order to finish your shift. Engross yourself in time-based chaos and find solutions by working with past versions of yourself.'}
      history={'Timeworks was chosen to be our first game after Colin Page showed off a game he made for a game jam to the rest of the team in November 2022. The Starworks team slowly started building out core features and testing levels with the Philadelphia gaming community. Early on the team focused on developing a tutorial to make the time-travel mechanics make sense for more players.\nIn June of 2023 Starworks secured funding to take their demo into a full commercial game on Steam. Using this funding, the team commissioned local jazz band Atomic Fizz to make the custom soundtrack for the game. The funds also allowed for more complex levels and trips to conventions like MAGFest and TooManyGames. Timeworks was released in March of 2024 after 18 months of development to positive reception on Steam providing a strong bass for the studio to build off of.'}
      features={[
        "Each of the over 50 levels has countless solutions and unlimited retries spanning across 3 unique environments. Show some real hustle to earn the coveted S rank or just breeze through each zone to climb the corporate ladder. Find your own unique way of playing Timeworks! Throw, stack, and sacrifice your past-self for higher corporate profits! Those clocks aren't going to make themselves, you know.",
        "Navigate NETS, avoid sticky slime, and toss handheld time machines in the Laboratory with Gary! Each zone has its own style of dynamic music from Philadelphia jazz band Atomic Fizz. As you travel back in time, the music travels with you creating this layering of groovy funky beats.",
        "Play over 10 hours of corporate satire and complete the Timeworks corporation's final task…",
      ]}
      steamLink="https://store.steampowered.com/widget/2667160/ "
      trailerUrls={[
        "https://www.youtube.com/embed/Ucag_S8tFW4",
      ]}
      screenshotUrls={[screenshot1, screenshot2, screenshot3, screenshot4, screenshot5, screenshot6, screenshot7, screenshot8, screenshot9, screenshot10, screenshot11, screenshot12, screenshot13, screenshot14]}
      logos={[logo1, logo2]}
      banners={[banner1, banner2, banner3]}
      mascots={[mascot1, mascot2, mascot3, mascot4, mascot5, mascot6]}
      aboutDeveloper={'🌟 Starworks Studios is a scrappy team of Drexel game developers working on games in Philadelphia starting in 2021.\n💫 Our core mission is to bring the easy and affordable fun of indie games to a wider market with high communication and fast turnaround to fans.'}
      aboutPublisher="Starworks Studios also self-publishes, ensuring full creative control and a direct connection with our community."
      credits="Colin Page - Designer & Developer
Ethan Whiting - Executive Producer
Thomas Ludin - Marketing Lead
Braden Kovalovich - Tech Lead
Owen Mearns - 3D & Environment Artist
Quinn Williams - Lead Animator
Carolina Escobar - 2D & Concept Artist
Brigitte Lubker - UI Artist
Camryn Schroder - Technical Artist
Mel Eager - Sound Designer
Idan Saban - Level Designer
Oliver Deinzer - Level Designer
Grady Milligan - 3D Artist"
    />
  );
};

export default TimeworksPresskit;
